import { render } from "./P018.vue?vue&type=template&id=07384e03&scoped=true"
import script from "./P018.vue?vue&type=script&lang=js"
export * from "./P018.vue?vue&type=script&lang=js"

import "./P018.vue?vue&type=style&index=0&id=07384e03&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07384e03"]])

export default __exports__